import { SidebarRecruitmentIndex } from "@/components/sidebar/recruit/components/SidebarRecruitmentIndex.tsx";
import { SidebarRecruitmentJobDetails } from "@/components/sidebar/recruit/components/SidebarRecruitmentJobDetails.tsx";
import { parseUrlHelper } from "@skailer-com/uikit";
import { useSearchParams } from "react-router-dom";

export const SidebarRecruitment = () => {
  const [searchParams] = useSearchParams();
  const jobId = parseUrlHelper.getNumberArray(searchParams, "job_id");

  return <>{jobId.length == 0 ? <SidebarRecruitmentIndex /> : <SidebarRecruitmentJobDetails />}</>;
};
